import React, { PureComponent } from "react";
import fan from "../../../../../images/TNCT-Fan-V3-2021-GC.png";
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from "react-bootstrap/Container";

class TNCTBanner extends PureComponent {
  render() {
    return (
      <Container>
        <Row className="tnct__container">
          <Card>
            <Row>
              <Col xs={12} className="tnct__title">
                <h2>
                  Already a Testbase school and want to upgrade to our National
                  Curriculum Tests?
                </h2>
              </Col>
            </Row>
            <Row className="tnct__div">
              <Col xs={8} md={8} className="tnct__grid">
                <p className="tnct__text">
                  Schools with 3 or fewer months left on their Testbase Primary Package
                  subscription can renew and extend their subscription for
                  £395 via the order form above. Please note no days are lost;
                  we will add 365 days to the existing subscription.
                </p>

                <p className="tnct__text">
                  Schools with more than 3 months left on their Testbase Primary Package
                  subscription can upgrade for £100 to align their existing
                  subscription end dates. To upgrade please email us at{" "}
                  <a
                    href="mailto:online@testbase.co.uk?subject=TNCT"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    online@testbase.co.uk
                  </a>
                </p>

                <p className="tnct__text">
                  <b>IMPORTANT</b>: Please be sure to include the following
                  information:
                </p>
                <ul className="tnct__list__text">
                  <li>Subject Line: TNCT</li>
                  <li>School name:</li>
                  <li>School postcode:</li>
                </ul>
              </Col>
              <Col
                xs={4}
                md={4}
                className="tnct__fan__holder"
              >
                <img src={fan} alt="fan" className="tnct__fan"></img>
              </Col>
            </Row>
          </Card>
        </Row>
      </Container>
    );
  }
}

export default TNCTBanner;
